import * as yup from 'yup'

export const schema = yup.object({
  title: yup.string().required(),
  description: yup.string().required(),
  startDate: yup.date().required(),
  duration: yup.number().required(),
  selectUser: yup.string(),
  host: yup.object({
    name: yup.string().required(),
    email: yup.string().email().required(),
  }),
  panelists: yup
    .array()
    .of(
      yup.object({
        name: yup.string().required(),
        email: yup.string().email().required(),
      })
    )
    .required(),
})

export type FormValues = yup.InferType<typeof schema>
